export default __webpack_public_path__ + "media/images/twitter-icon-c9f9e0fab6516e26dd6cf306fc20d4f4.svg";